import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  taxonomyDetailsHeader: {
    id: 'course-authoring.taxonomy-detail.side-card.header',
    defaultMessage: 'Taxonomy details',
  },
  taxonomyDetailsName: {
    id: 'course-authoring.taxonomy-detail.side-card.name',
    defaultMessage: 'Title',
  },
  taxonomyDetailsDescription: {
    id: 'course-authoring.taxonomy-detail.side-card.description',
    defaultMessage: 'Description',
  },
  taxonomyDetailsExportID: {
    id: 'course-authoring.taxonomy-detail.side-card.exportID',
    defaultMessage: 'Export ID',
  },
});

export default messages;
